export default __webpack_public_path__ + "static/media/JobSix14.ed02c500.jpg";